import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { IPayrollSheetApprovalAccessKey } from "@/payroll/payroll.d";

const NAMED_LIMIT = 6;

export const summarizeMissingApprovalNames = (
  accessKeys: IPayrollSheetApprovalAccessKey[],
) => {
  const names = accessKeys.map((accessKey) => accessKey.name);
  if (names.length <= NAMED_LIMIT) return names.join(", ");

  return `${names.slice(0, NAMED_LIMIT).join(", ")} and ${names.length - NAMED_LIMIT} more`;
};

export const getMissingApprovalHeadline = (
  accessKeys: IPayrollSheetApprovalAccessKey[],
) =>
  accessKeys.length === 1
    ? `${accessKeys[0].name} is not ready for PayPacks`
    : `${accessKeys.length} groups of sheets are not ready for PayPacks`;

/**
 * Concise context for a deliberately soft gate. Names enough outstanding units
 * to orient the sender without turning the send confirmation into an audit view.
 */
export const MissingTechApprovalWarning = ({
  accessKeys,
}: {
  accessKeys: IPayrollSheetApprovalAccessKey[];
}) => (
  <Alert color="warning" role="status" className="w-full">
    <WarningIcon />
    <AlertDescription>
      <Stack gap={1} align="stretch" className="w-full min-w-0">
        <Text variant="caption" className="font-semibold">
          {getMissingApprovalHeadline(accessKeys)}
        </Text>
        <Text variant="caption" tone="muted">
          {accessKeys.length > 1 &&
            `${summarizeMissingApprovalNames(accessKeys)}. `}
          PayPacks will still go out to everyone selected.
        </Text>
      </Stack>
    </AlertDescription>
  </Alert>
);
